import OperationLocalService from "../localStorage/OperationLocalService";
import OperationDistantService from "./OperationDistantService";
import AuthenticationLocalService from "../localStorage/AuthenticationLocalService";

export enum RequestStatus {
    ALL_GOOD,
    HALF_GOOD,
    NOTHING_GOOD
}

class SynchronizationService {

    public async synchronizeOperationData(): Promise<RequestStatus> {
        const operations = OperationLocalService.getOperationsBySync(false);
        let status: RequestStatus;
        const results: boolean[] = [];
        for(let i = 0; i < operations.length; i++) {
            await OperationDistantService.createOperation(operations[i])
                .then((response) => {
                    if(response.status === 200) {
                        operations[i].isSynchro = true;
                        OperationLocalService.updateOperation(operations[i]);
                    }
                    results.push(true);
                }).catch((err) => {
                    if(err.response!.status === 401) {
                        AuthenticationLocalService.logout();
                    } else {
                        console.log(err);
                    }
                    results.push(false);
                })
            ;
        }
        const nbOk = results.filter(value => value).length;
        if(nbOk === results.length) {
            status = RequestStatus.ALL_GOOD;
        } else if (nbOk === 0) {
            status = RequestStatus.NOTHING_GOOD;
        } else {
            status = RequestStatus.HALF_GOOD;
        }
        return status;
    }

}

export default new SynchronizationService();

